import { api } from "@/lib/api";

export const categoriesApi = {
    listTree: (activeOnly = false) =>
        api.get("/categories/tree", { params: { active_only: activeOnly } }).then((r) => r.data.items),

    list: (params = {}) => api.get("/categories", { params }).then((r) => r.data),

    get: (id) => api.get(`/categories/${id}`).then((r) => r.data),

    search: (q) => api.get("/categories/search", { params: { q } }).then((r) => r.data),

    create: (payload) => api.post("/categories", payload).then((r) => r.data),

    update: (id, payload) => api.patch(`/categories/${id}`, payload).then((r) => r.data),

    remove: (id, { force = false } = {}) =>
        api.delete(`/categories/${id}`, { params: force ? { force: true } : {} }).then((r) => r.data),

    usage: () => api.get("/categories/usage").then((r) => r.data),
};
